var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,20.56V37.541c0,6.218,0,6.218,5.877,10.182L22.038,57.05a9.77,9.77,0,0,0,8.815,0l16.161-9.328c5.877-3.963,5.877-3.963,5.877-10.182V20.56c0-6.218,0-6.218-5.877-10.182L30.852,1.051a9.77,9.77,0,0,0-8.815,0L5.877,10.378C0,14.341,0,14.341,0,20.56Z",
    transform: "translate(14.555 17.092)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.583,19.236V10.25Q37.583,0,27.333,0H10.25Q0,0,0,10.25V19",
    transform: "translate(22.208 6.833)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.369,1.384l1.947,3.041a2.976,2.976,0,0,0,1.5,1.093l3.485.888c2.153.547,2.733,2.392,1.333,4.1l-2.289,2.768a3.066,3.066,0,0,0-.581,1.777l.205,3.588c.137,2.221-1.435,3.348-3.485,2.528l-3.348-1.333a2.948,2.948,0,0,0-1.879,0L6.912,21.166c-2.05.82-3.622-.342-3.485-2.528l.2-3.588a2.989,2.989,0,0,0-.581-1.777L.762,10.506c-1.4-1.708-.82-3.553,1.333-4.1l3.485-.888a2.889,2.889,0,0,0,1.5-1.093L9.03,1.384C10.26-.461,12.174-.461,13.369,1.384Z",
    transform: "translate(29.783 36.165)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H82V82H0Z",
    transform: "translate(82 82) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.7821cdd34e11dbb33f0ff9572eded7b9.svg";
export { ForwardRef as ReactComponent };